import React from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';

function Title({text}) {
  return (
    <Helmet>
      <title>{text}</title>
    </Helmet>
  );
}

Title.propTypes = {
  /**
   * Text to display as page title
   */
  text: PropTypes.string.isRequired,
};

export default Title;
